module.exports = __webpack_public_path__ + "img/p2-25.e9c898d4.png";